<template>
  <div class="flex justify-center py-8">
    <nav class="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
      <button @click.prevent="decrementAdpage"
        class="relative inline-flex items-center px-5 py-4 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
        <span class="sr-only">Previous</span>
        <!-- Heroicon name: solid/chevron-left -->
        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
          aria-hidden="true">
          <path fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd" />
        </svg>
      </button>
      <button type="button" v-for="pageNumber in pagination" :key="pageNumber" @click.prevent="getAds(pageNumber)"
        class="relative inline-flex items-center px-8 py-4 border border-gray-300 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:ring-2 focus:ring-blue-600"
        :class="{
          'bg-indigo-100': pageNumber === currentPage
        }">
        {{ pageNumber }}
      </button>
      <button @click.prevent="incrementAdpage"
        class="relative inline-flex items-center px-5 py-4 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
        <span class="sr-only">Next</span>
        <!-- Heroicon name: solid/chevron-right -->
        <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
          aria-hidden="true">
          <path fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd" />
        </svg>
      </button>
    </nav>
  </div>
</template>

<script>
import { useStore } from "vuex";
import { computed } from "vue";
export default {
  name: "pagination",
  props: {
    totalElements: Number,
    pageView: Number,
    nameView: String
  },
  setup(props) {
    const store = useStore();

    const role = computed(() => store.state.role);
    const totalAdvertisements = computed(() => props.totalElements);
    const adsPerPage = computed(() => store.state.adsPerPage);
    const fill_limit = computed(() =>
      Math.ceil(totalAdvertisements.value / adsPerPage.value)
    );
    const user = computed(() => store.state.user);
    let currentPage = computed({
      get: () => props.pageView,
      set: (newValue) => {
        if (props.nameView === "Tiktoks") {
          store.commit("SET_PAGE_Tiktoks", newValue);
        } else if (props.nameView === "TopBrands") {
          store.commit("SET_PAGE_TopBrands", newValue);
        } else if (props.nameView === "Cases") {
          store.commit("SET_PAGE_Cases", newValue);
        } else if (props.nameView === "VerbalHooks") {
          store.commit("SET_PAGE_VERBAL_HOOKS", newValue);
        } else if (props.nameView === "UgcCreators") {
          store.commit("SET_PAGE_UgcCreators", newValue);
        } else {
          store.commit("SET_PAGE", newValue);
        }
      },
    });
    const pages = computed(() => {
      let pages = [];
      const numberPages =
        // ["annual"].includes(role.value)
        Math.ceil(totalAdvertisements.value / adsPerPage.value);
      // : Math.ceil(30 / adsPerPage.value);
      for (let i = 1; i <= numberPages; i++) {
        pages.push(i);
      }
      return pages;
    });

    const pagination = computed(() => {
      if (pages.value.length <= 5) {
        let numbersArray = [];
        for (var i = 1; i <= pages.value.length; i++) {
          numbersArray.push(i);
        }
        return numbersArray;
      }

      if (pages.value && pages.value.length) {
        let firtsSide = pages.value.slice(
          currentPage.value - 3,
          currentPage.value + 2
        );
        const lastSide = pages.value.length;

        const existInPagination = firtsSide.find(
          page => page === pages.value.length
        );

        if (existInPagination) {
          firtsSide = pages.value.slice(
            pages.value.length - 6,
            pages.value.length - 1
          );
          return [...firtsSide, lastSide];
        } else if (currentPage.value < 3) {
          firtsSide = pages.value.slice(0, 5);
          return [...firtsSide, "...", lastSide];
        } else {
          return [...firtsSide, "...", lastSide];
        }
      }
      return [];
    });

    const incrementAdpage = async () => {
      console.log(currentPage.value);
      if (currentPage.value < pages.value.length) {
        let valor = currentPage.value;
        await getAds(valor + 1);
      } else {
        // await store.commit("SET_OURPLANS_ACTIVE", true);
      }
    };

    const decrementAdpage = async () => {
      if (currentPage.value > 1) {
        let valor = currentPage.value;
        await getAds(valor - 1);
      }
    };

    const getAds = async (page) => {
      let newPage;
      if (page !== "...") {
        newPage = page;
        currentPage.value = page;
      } else {
        let lastPage =
          parseInt(
            pagination.value.toString().split(",...")[0].split(",").at(-1)
          ) + 1;
        newPage = lastPage;
        currentPage.value = lastPage;
      }
      if (fill_limit.value >= newPage && pages.value.length > 1) {
        if (props.nameView === "FbandIG") {
          await store.dispatch("GET_TOTAL_DISCOVER", { addedFilters: null });
          await store.dispatch("GET_ADVERTISEMENTS", { addedFilters: null });
          await store.dispatch("GET_TIKTOKS", { addedFilters: null, idUser: user.value.id });
        } else if (props.nameView === "Tiktoks") {
          await store.dispatch("GET_TIKTOKS", {
            addedFilters: null,
            idUser: user.value.id,
          });
        } else if (props.nameView === "TopBrands") {
          await store.dispatch("GET_TOP_BRANDS", { addedFilters: null });
        } else if (props.nameView === "Cases") {
          await store.dispatch("GET_CASES_STUDY");
        } else if (props.nameView === "VerbalHooks") {
          await store.dispatch("GET_VERBAL_HOOKS");
        } else if (props.nameView === "UgcCreators") {
          await store.dispatch("GET_UGC_CREATORS");
        } else {
          await store.dispatch("GET_TOTAL_DISCOVER", { addedFilters: null });
          await store.dispatch("GET_ADVERTISEMENTS", { addedFilters: null });
          await store.dispatch("GET_TIKTOKS", { addedFilters: null, idUser: user.value.id });
        }
        document.documentElement.scrollTop = 0;
      } else {
        // await store.commit("SET_OURPLANS_ACTIVE", true);
      }
    };

    return {
      role,
      totalAdvertisements,
      fill_limit,
      adsPerPage,
      pages,
      incrementAdpage,
      decrementAdpage,
      getAds,
      pagination,
      currentPage,
      user,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}

.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
